import * as React from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import Select from 'react-select';
import Spinner from '../../common/Loader/Spinner';
import * as countryList from 'react-select-country-list';

interface CardFormProps {
    billing_info: {
        fullName: string;
        postalCode: string;
        country: string;
    };
    billing_info_error: any;
    errorShow: boolean;
    processing: boolean;
    paymentIntentSucceeded: boolean;
    onChangeInfo: (keyName: string, value: any) => void;
    onCardChange: (evt: any) => void;
    handleSubmit: () => Promise<void>;
    onReset: () => void;
}

const CardForm: React.FC<CardFormProps> = (props: CardFormProps) => {
    const createCardIntent = () => {
        props.handleSubmit();
    };

    const countries = countryList().getData();
    const selectedCountry = countries.find(
        (c) => c.value == props?.billing_info?.country
    );
    return (
        <div className="payment-card--credit--container ">
            <div className="payment-card--credit--title--container">
                <span className="payment-card--credit--title">Credit card</span>
                <span
                    className="payment-card--credit--title--clear"
                    onClick={props.onReset}
                >
                    Clear
                </span>
            </div>
            {props.paymentIntentSucceeded && (
                <div
                    data-test="payment-card-blur"
                    className="payment-card--credit--container--blur"
                ></div>
            )}
            <CardFormRow
                label="Cardholder's name"
                keyName="fullName"
                errorShow={props.errorShow}
                errorMsg={props.billing_info_error.fullName}
                value={props.billing_info.fullName}
                onChangeInfo={props.onChangeInfo}
            />
            <div className="payment-card--credit--row">
                <span>Card information</span>

                <div className="payment-card--credit--row--card-wrapper">
                    <CardElement
                        options={{
                            hidePostalCode: false,
                            iconStyle: 'solid'
                        }}
                        onChange={(event) => {
                            props.onCardChange(event);
                        }}
                    />
                </div>
                {props.billing_info_error?.card ? (
                    <span className="form-group__error-msg">
                        {props.billing_info_error?.card}
                    </span>
                ) : null}
            </div>
            <div className="payment-card--credit--row ">
                <span>Country</span>
                <Select
                    className={'form-select--react-select react-select'}
                    classNamePrefix="react-select"
                    value={selectedCountry}
                    onChange={(value) =>
                        props.onChangeInfo('country', value.value)
                    }
                    menuPlacement={'top'}
                    options={countries}
                />
                {props.errorShow &&
                props.billing_info_error &&
                props.billing_info_error.country ? (
                    <span className="form-group__error-msg">
                        {props.billing_info_error.country}
                    </span>
                ) : null}
            </div>
            <div className="payment-card--credit--row">
                <button
                    className="btn btn--md btn--full btn--blue"
                    type="button"
                    onClick={createCardIntent}
                    data-test="continue-checkout"
                >
                    {props.processing && <Spinner size={'spinner-middle'} />}
                    &nbsp; Continue
                </button>
            </div>
        </div>
    );
};

export default CardForm;

interface ICardFormRowProps {
    label: string;
    keyName: string;
    value: string;
    onChangeInfo: (keyName: string, value: any) => void;
    errorShow: boolean;
    errorMsg: string;
}
const CardFormRow: React.FC<ICardFormRowProps> = (props: ICardFormRowProps) => {
    return (
        <div className="payment-card--credit--row">
            <span>{props.label}</span>
            <input
                name={props.keyName}
                type="text"
                value={props.value}
                placeholder={props.label}
                onChange={(e) =>
                    props.onChangeInfo(e.target.name, e.target.value)
                }
            />
            {props.errorShow && props.errorMsg ? (
                <span className="form-group__error-msg">{props.errorMsg}</span>
            ) : null}
        </div>
    );
};
